import Toastr from "../../../components/Toastr"
const parent = 'SETTING_'

const DEFAULT_STATE = {
  survey_parameters: [],
  survey_parameter: {},
  meta: {pagination: {}},
  saving: false
}
let changes = null;
export default function surveyParameterReducer(state = DEFAULT_STATE, action){
  const response = action.payload && (action.payload.data || action.payload.response)
  let surveyParameters = [];
  let surveyParameterData = [];
  let updatedRecord = {};
  switch(action.type){
    case `${parent}SURVEY_PARAMETERS_LOAD_PENDING`:
    case `${parent}SURVEY_PARAMETER_LOAD_PENDING`:
      return {...state, saving: false};

    case `${parent}SURVEY_PARAMETER_CREATE_PENDING`:
    case `${parent}SURVEY_PARAMETER_UPDATE_PENDING`:
      return {...state, saving: true};

    case `${parent}SURVEY_PARAMETERS_LOAD_REJECTED`:
    case `${parent}SURVEY_PARAMETER_LOAD_REJECTED`:
    case `${parent}SURVEY_PARAMETER_CREATE_REJECTED`:
    case `${parent}SURVEY_PARAMETER_UPDATE_REJECTED`:
    case `${parent}SURVEY_PARAMETER_DELETE_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.status_code)
      changes = {
        saving: false
      }
      return {...state,...changes};

    case `${parent}SURVEY_PARAMETERS_LOAD_FULFILLED`:
      changes = {
        ...response,
        saving: false
      };
      return {...state, ...changes};
    
    case `${parent}SURVEY_PARAMETER_LOAD_FULFILLED`:
      changes = {
        survey_parameter: response.survey_parameter,
        saving: false
      }
      return {...state,...changes};
    
    case `${parent}SURVEY_PARAMETER_CREATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      surveyParameters = [...state.survey_parameters]
      let newRecord = response.survey_parameter
      changes = {
        survey_parameters: [...surveyParameters, newRecord],
        editing: false,
        saving: false
      }
      return {...state, ...changes};

    case `${parent}SURVEY_PARAMETER_UPDATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      surveyParameters = [...state.survey_parameters];
      updatedRecord = response.survey_parameter;
      for (const [index, surveyParameter] of surveyParameters.entries()) {
        if (surveyParameter.id === updatedRecord.id) {
          surveyParameterData = [
            ...surveyParameters.slice(0, index),
            updatedRecord,
            ...surveyParameters.slice(index + 1)
          ];
        }
      }
      changes = {
        survey_parameters: surveyParameterData,
        editing: false,
        saving: false
      };
      return { ...state, ...changes };

    case `${parent}SURVEY_PARAMETER_DELETE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      surveyParameters = [...state.survey_parameters];
      for (const [index, surveyParameter] of surveyParameters.entries()) {
        if (surveyParameter.id === response.survey_parameter.id) {
          surveyParameters.splice(index, 1);
        }
      }
      return {
        ...state,
        survey_parameters: surveyParameters,
        error: null
      };

    case `${parent}SURVEY_PARAMETER_EDIT`:
      changes = {
        editing: {
          id: action.id,
        },
        survey_parameter: {}
      };
      return { ...state, ...changes };

    case `${parent}SURVEY_PARAMETER_EDIT_CANCEL`:
      changes = {
        editing: false
      };
      return { ...state, ...changes };

    default:
      return state;
  }
}